module.exports = __webpack_public_path__ + "static/media/value-hat.a090c1ad.svg";